import { createApi } from '@fe-toolkit/axios-api-toolkit'

import { z } from 'zod'

import axiosInstance from '@/api/client'

import { MemberSchema } from './member.schema'

const TIMEOUT = 5000 // 5 seconds

const memberApi = createApi(axiosInstance, createEndpoint => ({
  getMemberDetails: createEndpoint(
    {
      url: `/member-api/v1/members/me`,
      method: 'GET',
      requestSchema: z.object({}),
      responseSchema: MemberSchema,
    },
    {
      timeout: TIMEOUT,
    },
  ),
}))

export default memberApi
